import type { MutableRefObject } from 'react';

/**
 * Keeps a question's publish as the pending one until it settles, so a stop
 * can wait for the backend to acknowledge the question before stopping it.
 * @param pendingRef - Holds the publish still waiting on its acknowledgment.
 * @param publishing - The question's publish request.
 * @returns The publish, settling as it does.
 */
export const trackPendingPublish = <T>(
  pendingRef: MutableRefObject<Promise<unknown> | null>,
  publishing: Promise<T>
): Promise<T> => {
  pendingRef.current = publishing;
  return publishing.finally(() => {
    if (pendingRef.current === publishing) {
      pendingRef.current = null;
    }
  });
};
